import { css } from '@emotion/react';

export const buyerRegistrationStyles = {
  widgetBody: css`
    margin: 50px auto;
    padding: 32px;
    max-width: 650px;
  `,
};
